import { render, staticRenderFns } from "./dog-purchase-public.vue?vue&type=template&id=38570766&scoped=true&lang=pug"
import script from "./dog-purchase-public.js?vue&type=script&lang=js&external"
export * from "./dog-purchase-public.js?vue&type=script&lang=js&external"
import style0 from "./dog-purchase-public.vue?vue&type=style&index=0&id=38570766&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38570766",
  null
  
)

export default component.exports